// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__1-20I","fade":"styles_fade__2ffaQ"};